import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';

export interface DialogData {
  title: string;
  description: string;
  buttonTitleYes?: string;
  buttonTitleNo?: string;
}

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
})
export class ConfirmationDialogComponent {
  title: string;
  description: string;
  buttonTitleYes: string = 'Ja';
  buttonTitleNo: string = 'Nein';

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.title = data.title;
    this.description = data.description;
    if (data.buttonTitleYes && data.buttonTitleNo) {
      this.buttonTitleYes = data.buttonTitleYes;
      this.buttonTitleNo = data.buttonTitleNo;
    }
  }
}
